<template>
  <PluginItemAction
    id="duplicate"
    :title="$t('duplicate', 'Duplicate')"
    :disabled="!canDuplicate"
    meta
    key-code="D"
    multiple
    icon="duplicate"
    :weight="-90"
    @click="onClick"
  />
</template>

<script setup>
import { computed, useBlokkli, defineBlokkliFeature } from "#imports";
import { PluginItemAction } from "#blokkli/plugins";
import { getFieldKey } from "#blokkli/helpers";
const { state, $t, selection, types } = useBlokkli();
const { adapter } = defineBlokkliFeature({
  id: "duplicate",
  icon: "duplicate",
  label: "Duplicate",
  requiredAdapterMethods: ["duplicateBlocks"],
  description: "Provides an action to duplicate one or more blocks in place."
});
function onClick(items) {
  state.mutateWithLoadingState(
    () => adapter.duplicateBlocks(items.map((v) => v.uuid)),
    $t("duplicateError", "The items could not be duplicated.")
  );
}
const canDuplicate = computed(() => {
  if (state.editMode.value !== "editing") {
    return false;
  }
  const blocksByField = {};
  const fieldsByKey = {};
  const selectedCount = selection.blocks.value.length;
  for (let i = 0; i < selectedCount; i++) {
    const block = selection.blocks.value[i];
    const field = state.getMutatedField(block.hostUuid, block.hostFieldName);
    if (!field) {
      continue;
    }
    const fieldKey = getFieldKey(field.entityUuid, field.name);
    const fieldConfig = types.getFieldConfig(
      field.entityType,
      block.hostBundle,
      field.name
    );
    if (!fieldConfig) {
      continue;
    }
    const count = field.list.length;
    if (fieldConfig.cardinality !== -1 && count >= fieldConfig.cardinality) {
      return false;
    }
    if (!blocksByField[fieldKey]) {
      blocksByField[fieldKey] = [];
    }
    blocksByField[fieldKey].push(block);
    fieldsByKey[fieldKey] = {
      cardinality: fieldConfig.cardinality,
      allowedBundles: fieldConfig.allowedBundles,
      count
    };
  }
  const entries = Object.entries(blocksByField);
  for (let i = 0; i < entries.length; i++) {
    const [fieldKey, blocks] = entries[i];
    const field = fieldsByKey[fieldKey];
    if (!field) {
      return false;
    }
    const count = state.getFieldBlockCount(fieldKey);
    if (field.cardinality !== -1 && count + blocks.length > field.cardinality) {
      return false;
    }
    const bundles = blocks.map((v) => v.itemBundle);
    if (!field.allowedBundles.length || bundles.some((bundle) => !field.allowedBundles.includes(bundle))) {
      return false;
    }
  }
  return true;
});
</script>

<script>
export default {
  name: "Duplicate"
};
</script>
